import { render, staticRenderFns } from "./balanceDetail.vue?vue&type=template&id=1343fb98&scoped=true&"
import script from "./balanceDetail.vue?vue&type=script&lang=js&"
export * from "./balanceDetail.vue?vue&type=script&lang=js&"
import style0 from "./balanceDetail.vue?vue&type=style&index=0&id=1343fb98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1343fb98",
  null
  
)

export default component.exports